
<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<template v-else>
			<div class="text-right mb-2">
				<router-link :to="{ name: 'impayesList' }" class="small">
					{{ $t('compta.impayes') }} →
				</router-link>
			</div>

			<b-table
				:items="tableItems"
				small
				bordered
				thead-class="d-none"
			>
				<template #cell(label)="{ value }">
					<span class="d-block text-center">{{ value }}</span>
				</template>
				<template #cell(value)="{ value }">
					<span class="d-block text-center">{{ value }}</span>
				</template>
			</b-table>
		</template>
	</div>
</template>

<script type="text/javascript">
import Common from '@/assets/js/common.js'
import InvoiceMixin from '@/mixins/Invoice.js'
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetUnpaid',
	mixins: [InvoiceMixin, DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			tableItems: [],
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			const accountingPlanId = this.widget.dashboardwidgets_config.entite
			const res = await this.getUnpaidInvoices(null, null, accountingPlanId)
			const duedates = res && res.duedates ? res.duedates : []
			const currency = res ? res.currency : null

			let total = 0
			for (const d of duedates) {
				total += d.duedate_balance
			}

			const totalUnpaid = await Common.priceFormat(total, currency, true)
			const totalTiers = new Set(duedates.filter(d => d.invoice.tiers).map(d => d.invoice.tiers.tiers_id)).size

			this.tableItems = [
				{ label: this.$t('payment.total_impaye'), value: totalUnpaid },
				{ label: this.$t('payment.nb_tiers_concernes'), value: totalTiers },
			]
			this.loading = false
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
